export default {
  id: 'nl-chamahq@07982|02519062276054286169',
  creationTime: '2017-05-29T15:53:14.5713830Z',
  modificationTime: '2017-05-30T08:36:08.6993303Z',
  eTag: 'W/"datetime\'2017-05-30T08%3A36%3A08.8373209Z\'"',
  phone: '+552423456789',
  address: 'Testing the thing',
  lat: 0,
  lon: 0,
  dealerId: 'nl-chamahq',
  products: [
    {
      id: 'GASP13-SUPERGASBRAS',
      quantity: 1,
      price: 65,
    },
  ],
  status: 'dealerProcessing',
  dealerRating: 4,
  paymentType: 'cash',
  currentTicket: {
    id: 'nl-chamahq@07982|02519062276048458423',
    eTag: 'W/"datetime\'2017-05-30T08%3A36%3A09.0995067Z\'"',
    isAssignedToCurrentUser: true,
    assignedToUserId: 'reinder@nl-chamahq',
    type: 'newOrder',
    status: 'inProgress',
    executionTemplates: [
      {
        action: 'acceptOrder',
        parameters: {
          address: '',
          driverId: '',
          etaMinutes: '',
        },
      },
      {
        action: 'declineOrder',
      },
    ],
    creationTime: '2017-05-29T15:53:15.1541576Z',
    modificationTime: '2017-05-30T08:36:08.6524519Z',
    dueTime: '2017-05-29T15:58:15.1541576Z',
    queue: 'incoming',
  },
  dealer: {
    id: 'nl-chamahq',
    name: 'Chama',
    lat: 52.361973,
    lon: 48.72909,
    products: [
      {
        id: 'GASP13-SUPERGASBRAS',
        type: 'GASP13',
        brand: 'SUPERGASBRAS',
        price: 65,
      },
    ],
    rating: 4.3,
    phone: '+31625442726',
    isOpened: true,
    willOpenAt: '2017-05-30T03:00:00.0000000Z',
    willCloseAt: '2017-05-29T23:00:00.0000000Z',
    openingTimes: {
      monday: {
        open: '2:00',
        close: '20:00',
      },
      tuesday: {
        open: '0:00',
        close: '20:00',
      },
      wednesday: {
        open: '0:00',
        close: '23:59',
      },
      thursday: {
        open: '0:00',
        close: '23:59',
      },
      friday: {
        open: '0:00',
        close: '23:59',
      },
      saturday: {
        open: '0:00',
        close: '20:00',
      },
      sunday: {
        open: '2:00',
        close: '20:00',
      },
    },
  },
};



// WEBPACK FOOTER //
// ../utils/mocks/order.js